import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1x0yjfx-0"
})(["display:flex;flex-direction:column;justify-content:center;color:", ";", ";span{display:flex;flex-direction:row;font-size:", ";line-height:", ";max-height:fit-content;svg{margin-right:", ";}&:last-of-type{flex:1;align-items:center;font-size:", ";}}"], function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(16);
});
export var BillIncluded = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1x0yjfx-1"
})(["", " ", ""], function (props) {
  return props.hasMaxAmount && "\n      font-weight: 700;\n\n      span {\n        display: inline-block;\n        font-weight: 400;\n        margin-left: ".concat(props.theme.space(1), ";\n      }\n    ");
}, function (props) {
  return !props.hasMaxAmount && "\n      color: ".concat(props.theme.servicesExpensesSection.billsGridItem.colors.billIncluded, ";\n    ");
});